import * as React from "react";
const SvgIconColorQuadrat = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Ebene_1", "data-name": "Ebene 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 50", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 50, height: 50, rx: 7.5, ry: 7.5 }));
export default SvgIconColorQuadrat;
